/*
FG - FOOF - AFTER CERT - FIRST RELEASE ----
THIS IS THE PERSONNEL DASHBOARD CODE
IT IS NOT BEING USED IN THE FIRST RELEASE
IF THIS CODE GETS REINSTATED IT MUST BE EVALUATED
TO BE SURE IT DOES NOT CAUSE ANY PROBLEMS (i.e. 
THERE ARE PLACES WHERE THE CONTROLLER/SERVICE 
MAY EXPECT A LOCATION OF NULL OR ZERO... THAT WILL
NOT FLUSH WITH THE FIRST RELEASE CODE)
*/
import * as service from './profiledashboard.service'
export default {
  data() {
    return {

      locationId:'',
      locationName:'',
      employees:[],
      currentRole:'',
      stateName:'',
      cindex:''

    }
  },
  mounted() {
    let context = this
    this.currentRole = authDetails.role
    this.stateName = this.$route.name
    this.$router.app.$on('emittedlocation_obj', (data) => {
      context.locationId = data.LocationId ? data.LocationId : ''
      context.locationName = data.LocationName ? ' - ' + data.LocationName : ''
      if(context.locationId || context.locationId == 0)
      {
        context.GetPersonnelMinDetailsByLocation(context.locationId?context.locationId : 0)
      }

      // alert(JSON.stringify(data))

    })
  },
  props: ['data', 'editShow'],
  methods: {
    backProfile(){
      this.$router.push('/addpersonnel')

    },
    geteDetails(index)
    {

      this.cindex = index

    },
    GetPersonnelMinDetailsByLocation(locationId) {
      let context = this
      loader.startLoader()
      service.GetPersonnelMinDetailsByLocation(locationId).then(function (response) {

        if (response && response != null) {
          context.employees = response
        //  tooltip.startTooltip(50)
        }
        else {

          context.employees = []
        }

        //context.$refs.dragtable.setPage(1)

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },


  },

  watch: {
    '$route' (to, from) {

      this.stateName = to.name
      if(from.name == 'login' || from.name== 'signupconfirm')
      {

        $.event.trigger({
          type: 'newMessage'

        })
      }
    }
  },

}



// WEBPACK FOOTER //
// ./src/components/ProfileDashboard/profiledashboard.controller.js